/* Hello couleur — historique « Vous avez consulté récemment ».
   - Sur une fiche produit (le snippet hc-recent-views.liquid emet un
     <div data-hc-recent-view ...>), push {slug, name, img, price, url} dans
     localStorage (cle hc_recent_v1, dedupe, FIFO max 8).
   - Sur n'importe quelle page qui charge ce script, injecte une section avant
     <footer> avec les 5 derniers items (exclut le slug courant). Affiche rien
     si l'historique est vide ou ne contient que le slug courant.
   Style : .recent-views / .recent-views__title / .recent-views__grid /
   .recent-views__card / .recent-views__info / .recent-views__name /
   .recent-views__price defini dans design-system.css.liquid (fond galet). */
(function () {
  var STORAGE_KEY = 'hc_recent_v1';
  var MAX_STORED = 8;
  var MAX_SHOWN = 5;

  function readList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function writeList(arr) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); } catch (e) {}
  }

  // Slug courant : depuis le marqueur emis par le snippet, sinon depuis l'URL
  // Shopify /products/SLUG (cookies, fragments, query OK).
  function currentSlug() {
    var marker = document.querySelector('[data-hc-recent-view]');
    if (marker && marker.dataset.slug) return marker.dataset.slug;
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return m ? m[1] : null;
  }

  function trackCurrentView() {
    var marker = document.querySelector('[data-hc-recent-view]');
    if (!marker) return;
    var slug = marker.dataset.slug;
    if (!slug) return;
    var item = {
      slug: slug,
      name: marker.dataset.name || '',
      url: marker.dataset.url || ('/products/' + slug),
      img: marker.dataset.img || '',
      price: marker.dataset.price || ''
    };
    if (!item.name || !item.img) return;
    var list = readList().filter(function (x) { return x.slug !== slug; });
    list.unshift(item);
    if (list.length > MAX_STORED) list = list.slice(0, MAX_STORED);
    writeList(list);
  }

  function buildSection(items) {
    var section = document.createElement('section');
    section.className = 'section recent-views';
    section.id = 'recent-views';
    section.setAttribute('aria-labelledby', 'recent-views-title');
    var container = document.createElement('div');
    container.className = 'container';
    var title = document.createElement('h2');
    title.id = 'recent-views-title';
    title.className = 'recent-views__title';
    title.textContent = 'Vous avez consulté récemment';
    container.appendChild(title);
    var grid = document.createElement('div');
    grid.className = 'recent-views__grid';
    items.forEach(function (it) {
      var a = document.createElement('a');
      a.className = 'recent-views__card';
      a.href = it.url;
      var img = document.createElement('img');
      img.loading = 'lazy';
      img.decoding = 'async';
      img.src = it.img;
      img.alt = it.name;
      var info = document.createElement('div');
      info.className = 'recent-views__info';
      var name = document.createElement('div');
      name.className = 'recent-views__name';
      name.textContent = it.name;
      info.appendChild(name);
      if (it.price) {
        var price = document.createElement('div');
        price.className = 'recent-views__price';
        price.textContent = it.price;
        info.appendChild(price);
      }
      a.appendChild(img);
      a.appendChild(info);
      grid.appendChild(a);
    });
    container.appendChild(grid);
    section.appendChild(container);
    return section;
  }

  function render() {
    var slug = currentSlug();
    var items = readList().filter(function (it) { return it.slug !== slug; }).slice(0, MAX_SHOWN);
    if (items.length === 0) return;
    if (document.getElementById('recent-views')) return;
    var anchor = document.querySelector('.reassurance') || document.querySelector('footer.footer, footer');
    if (!anchor) return;
    anchor.parentNode.insertBefore(buildSection(items), anchor);
  }

  function init() {
    trackCurrentView();
    render();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
